import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { IonContent, IonPage } from "@ionic/react";
import { Row, Col, Form, Typography } from "antd";

import log from "../utils/log";
import _ from "lodash";
import { showErrMsg } from "../utils/error";

//
import Header from "../components/GetStarted/Header";
import SectionHeader from "../components/GetStarted/SectionHeader";
import Description from "../components/General/Description";
import Contact from "../components/General/Contact";
import Gallery from "../components/General/Gallery";

//
import useRequestStore from "../states/useRequest";
import useAuthStore from "../states/useAuth";
import useCompany from "../hooks/useCompany";
import useRequest from "../hooks/useRequest";

const { Text, Paragraph } = Typography;

const GetStartedShop2 = () => {
  const history = useHistory();
  const { user } = useAuthStore();
  const { newCompany, newBrand, newShop } = useRequestStore();
  const { createCompany } = useRequest();

  const [shopForm] = Form.useForm();
  const [shop, setShop] = useState(newShop);
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);

  const readOnly = useMemo(() => {
    let { shop: canUpdate } = user?.permission || {};
    // log.debug(canUpdate);
    return !canUpdate;
    // return false;
  }, [user]);

  const handleNextStep = async () => {
    let { description, openHour, phone, website, email, gallery } = shop;

    //parse
    if (email) {
      email = email.trim();
    }

    let partOfShopInfo = { description, openHour, phone, email, website, gallery };
    log.debug(partOfShopInfo);
    
    //axios
    try {
      setIsLoadingCreate(true);
      let result = await createCompany({
        company: newCompany,
        brand: newBrand,
        shop: _.merge({}, newShop, partOfShopInfo),
      });
      setIsLoadingCreate(false);
      history.push("/merchantUser/home");
    } catch (error) {
      setIsLoadingCreate(false);
      showErrMsg(error);
    }
  };

  const updateShopData = (newData) => {
    log.debug(newData);
    setShop((prev) => {
      // Create a copy of the previous shop data
      let updated = _.merge({}, prev, newData);

      if (newData.gallery) {
        updated.gallery = newData.gallery;
      }
      return updated;
    });
  };

  return (
    <IonPage>
      <IonContent>
        <Header
          step={2}
          nextLabel={"Submit"}
          loading={isLoadingCreate}
          onBack={() => {
            history.goBack();
          }}
          onNext={() => {
            handleNextStep();
          }}
        />

        <Row justify="center" style={{ width: "100%" }}>
          <Row style={{ maxWidth: "50vw", padding: "20px" }}>
            <h1 style={{ width: "100%", fontSize: "32px", fontWeight: "bold", marginBottom: "0.5rem" }}>
              Shop Profile (optional)
            </h1>
            <p style={{ color: "#666", marginBottom: "24px" }}>
              The following information is optional and can be updated later.
            </p>

            <SectionHeader title="About the Shop" />
            <Description
              state={{
                data: shop?.description,
                form: shopForm,
                onChange: updateShopData,
                keyName: "description",
              }}
              readOnly={readOnly}
              placeholder={"A brief description of your shop"}
            />

            <SectionHeader
              title="Open Hour"
              description={readOnly ? null : "If open hours is included, it should be in 12-hour clock format."}
            />
            <Paragraph type="secondary" style={{ whiteSpace: "pre-wrap" }}>
              {`Example: 
Mon: 9 AM - 1 PM | 3 PM - 8 PM
Tue: 9 AM - 1 PM | 3 PM - 8 PM
Wed: 9 AM - 1 PM | 3 PM - 8 PM
Thu: 9 AM - 1 PM | 3 PM - 8 PM
Fri: 9 AM - 1 PM | 3 PM - 8 PM
Sat: 9 AM - 8 PM
Sun: 9 AM - 8 PM`}
            </Paragraph>
            <Description
              state={{
                data: shop?.openHour,
                form: shopForm,
                onChange: updateShopData,
                keyName: "openHour",
              }}
              readOnly={readOnly}
              placeholder={"Open hours of your shop"}
            />

            <SectionHeader title="Contact" />
            <Contact
              state={{
                phone: shop?.phone,
                email: shop?.email,
                website: shop?.website,
                form: shopForm,
                onChange: updateShopData,
              }}
              readOnly={readOnly}
            />

            <SectionHeader
              title="Shop Gallery"
              description={
                readOnly
                  ? null
                  : "Max 4 photos. 16:9, JPG or PNG. Max size of 5MB, You can delete or change the order of the photos."
              }
            />
            <Gallery
              state={{
                data: shop?.gallery,
                onChange: updateShopData,
              }}
              readOnly={readOnly}
              aspect={16/9}
            />
          </Row>
        </Row>
        <Row style={{ height: "5rem" }}></Row>
      </IonContent>
    </IonPage>
  );
};

export default GetStartedShop2;
